export enum ChatMessageRole {
  System = 'system',
  User = 'user',
  Assistant = 'assistant',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
  ASSISTANT = 'ASSISTANT',
}

export const ACTIONS = {
  WIDGET_LOAD: 'widget load',
  BUTTON_CLICK: 'button click',
};

export const SHOW_MORE_KEY = 'theme_assistant_widget_show_more_cta';
